import type { NormalizedPoint } from '../model';

// ADR 0026 D2 -- kept apart from haptoBonds.ts so the drawing projections can use it.

/** The middle of `atomIds` (the point a hapto bond is drawn to), from `position`. */
export function centroidOf(
  atomIds: readonly string[],
  position: (atomId: string) => NormalizedPoint | undefined
): NormalizedPoint | undefined {
  const points = atomIds.flatMap((id) => {
    const point = position(id);
    return point ? [point] : [];
  });
  if (points.length === 0) return undefined;
  return {
    x: points.reduce((sum, point) => sum + point.x, 0) / points.length,
    y: points.reduce((sum, point) => sum + point.y, 0) / points.length
  };
}
